module.exports = __webpack_public_path__ + "img/692.52f514d6.jpg";